import { LivenessDisplayText } from "@aws-amplify/ui-react-liveness/dist/types/components/FaceLivenessDetector/displayText"

export const defaultErrorDisplayText = {
    errorLabelText: 'Erro',
    connectionTimeoutHeaderText: 'Tempo de conexão esgotado',
    connectionTimeoutMessageText: 'A conexão foi interrompida.',
    timeoutHeaderText: 'Tempo esgotado',
    timeoutMessageText: 'O rosto não se encaixou dentro do oval no limite de tempo. Tente novamente e preencha completamente o oval com seu rosto.',
    faceDistanceHeaderText: 'Movimento para frente detectado',
    faceDistanceMessageText: 'Evite se aproximar ao conectar.',
    multipleFacesHeaderText: 'Múltiplos rostos detectados',
    multipleFacesMessageText: 'Garanta que haja apenas um rosto na frente da câmera ao conectar.',
    clientHeaderText: 'Erro do cliente',
    clientMessageText: 'A verificação falhou devido a um problema no cliente',
    serverHeaderText: 'Problema no servidor',
    serverMessageText: 'Não é possível concluir a verificação devido a um problema no servidor',
    landscapeHeaderText: 'Orientação paisagem não suportada',
    landscapeMessageText: 'Gire seu dispositivo para a orientação retrato (vertical).',
    portraitMessageText: 'Garanta que seu dispositivo permaneça na orientação retrato (vertical) durante a verificação.',
    tryAgainText: 'Tente novamente',
}

export const defaultLivenessDisplayText: LivenessDisplayText = {
    cameraMinSpecificationsHeadingText: 'A câmera não atende às especificações mínimas',
    cameraMinSpecificationsMessageText: 'A câmera deve suportar pelo menos resolução de 320*240 e 15 quadros por segundo.',
    cameraNotFoundHeadingText: 'Câmera não acessível.',
    cameraNotFoundMessageText: 'Verifique se a câmera está conectada e se não há outro aplicativo usando a câmera. Pode ser necessário acessar as configurações para conceder permissões de câmera e fechar todas as instâncias do seu navegador e tentar novamente.',
    a11yVideoLabelText: 'Webcam para verificação de liveness',
    cancelLivenessCheckText: 'Cancelar verificação de Liveness',
    goodFitCaptionText: 'Boa posição',
    goodFitAltText: 'Ilustração do rosto de uma pessoa, perfeitamente encaixado dentro de um oval.',
    hintCenterFaceText: 'Centralize seu rosto',
    hintCenterFaceInstructionText: 'Instrução: Antes de iniciar a verificação, certifique-se de que sua câmera está no centro superior da tela e centralize seu rosto na câmera. Quando a verificação começar, um oval aparecerá no centro. Você será solicitado a mover-se para dentro do oval e depois segurar a posição. Após alguns segundos em que você ficar imóvel, a verificação será concluída.',
    hintFaceOffCenterText: 'O rosto não está no oval, centralize seu rosto na câmera.',
    hintMoveFaceFrontOfCameraText: 'Mova o rosto para frente da câmera',
    hintTooManyFacesText: 'Garanta que haja apenas um rosto na frente da câmera',
    hintFaceDetectedText: 'Rosto detectado',
    hintCanNotIdentifyText: 'Mova o rosto para frente da câmera',
    hintTooCloseText: 'Afaste-se',
    hintTooFarText: 'Aproxime-se',
    hintConnectingText: 'Conectando...',
    hintVerifyingText: 'Verificando...',
    hintCheckCompleteText: 'Verificação concluída',
    hintIlluminationTooBrightText: 'Mova-se para uma área mais escura',
    hintIlluminationTooDarkText: 'Mova-se para uma área mais iluminada',
    hintIlluminationNormalText: 'Condições de iluminação normais',
    hintHoldFaceForFreshnessText: 'Fique imóvel',
    hintMatchIndicatorText: '50% concluído. Continue se aproximando.',
    photosensitivityWarningBodyText: 'Esta verificação pisca com diferentes cores. Tenha cuidado se você for fotossensível.',
    photosensitivityWarningHeadingText: 'Aviso de fotossensibilidade',
    photosensitivityWarningInfoText: 'Algumas pessoas podem ter convulsões epilépticas quando expostas a luzes coloridas. Tenha cuidado se você ou alguém em sua família tiver uma condição epiléptica.',
    photosensitivityWarningLabelText: 'Mais informações sobre fotossensibilidade',
    retryCameraPermissionsText: 'Tentar novamente',
    recordingIndicatorText: 'Gravando',
    startScreenBeginCheckText: 'Iniciar verificação de vídeo',
    tooFarCaptionText: 'Muito longe',
    tooFarAltText: 'Ilustração do rosto de uma pessoa dentro de um oval; há um espaço entre o perímetro do rosto e as bordas do oval.',
    waitingCameraPermissionText: 'Aguardando você permitir a permissão da câmera.',
    ...defaultErrorDisplayText,
}

const livenessDictionary = {
    ...defaultLivenessDisplayText,
}

export default livenessDictionary